import { MODAL_ID } from './modalCarousel';

let uppyState = {};
export function updateUppyState({ inputName, files }) {
  uppyState = {
    ...uppyState,
    [inputName]: files,
  };
}

$(document).on('click', '.file_upload_field-display', function displayFileUploafField() {
  const uppy = $(this).parent().next('.react_fileUploadField');
  const carret = this.querySelector('.fa-angle-down');
  carret.classList.toggle('rotated');

  uppy.toggleClass('hidden');

  const uppyPosition = uppy[0].getBoundingClientRect();
  const container = document.querySelector('.main-content__container');
  if (uppyPosition.bottom > container.clientHeight) {
    const scrollableDivYPosition = container.scrollTop - container.getBoundingClientRect().top;
    container.scrollTop = scrollableDivYPosition + uppyPosition.bottom - container.clientHeight + 20;
  }
});

$(document).on('click', '.edit_file', function editFile() {
  const fileId = $(this).attr('id').split('_')[0];
  const metadataContainer = $(`#${fileId}_metadata`);

  if (metadataContainer.hasClass('hidden')) {
    metadataContainer.removeClass('hidden');
  } else {
    metadataContainer.addClass('hidden');
  }
});

$(document).on('click', '.remove_file', function removeFile() {
  /**
   * Manage file removal buttons.
   */
  const filePreview = $(this).parent('.file-preview');
  const filePreviewInline = filePreview.parent('.file-preview-inline');
  const fileBlock = filePreviewInline.length ? filePreviewInline : filePreview;

  const fileId = filePreview.find('a.file-gallery').data('file-id');
  const modalItem = $(MODAL_ID).find(`li[data-file-id="${fileId}"]`);
  const modalCaption = $(MODAL_ID).find('div.carousel-inner').find(`div[data-file-id="${fileId}"`);
  if (modalItem) {
    modalItem.remove();
  }
  if (modalCaption) {
    modalCaption.remove();
  }

  const input = $('<input>', {
    name: 'remove_files',
    value: $(this).data('value'),
    type: 'hidden',
  });
  $(this).closest('.form-group').append(input);
  // Needed for handling conditionalShowing on this type of generated <input>.
  input.trigger('change');

  // If form-control-static is empty, remove it to avoid weird padding.
  const formControl = fileBlock.parent('.form-control-static');
  fileBlock.remove();
  if (!formControl.children().length) {
    formControl.remove();
  }
});

function createUploadInputElement(inputName, type, value) {
  const input = document.createElement('input');
  input.type = type;
  input.id = inputName;
  input.name = inputName;
  input.className = 'hidden';

  if (type === 'file') {
    input.files = value;
  } else {
    input.value = value;
  }

  return input;
}

function createTypeAndDescriptionInputs(form, file, inputName, index) {
  const typeInputName = `${inputName}-category#${index + 1}`;
  if (!document.getElementById(typeInputName)) {
    // noinspection JSUnresolvedVariable
    const typeInputEl = createUploadInputElement(typeInputName, 'text', file.meta.category || '');
    form.appendChild(typeInputEl);
  }

  const descInputName = `${inputName}-description#${index + 1}`;
  if (!document.getElementById(descInputName)) {
    const descInputEl = createUploadInputElement(descInputName, 'text', file.meta.description || '');
    form.appendChild(descInputEl);
  }
}

export function addUppyFieldsToForm(form) {
  /**
   * FileUploadFields use Uppy. Files added to Uppy are stored in the Redux store, not in the form.
   * To submit the files to the server, add the inputs (file, type, description) to the form.
   */
  Object.entries(uppyState).forEach(([inputName, files]) => {
    // Atm the consultation can have multiple forms on one page.
    // Do not add fields from forms not being submitted.
    const escapedId = inputName.replace('/', '\\/');
    if (!$(form).find(`div[data-input-name=${escapedId}]`).length) {
      return;
    }

    Object.values(files).forEach((file, index) => {
      const fileInputName = `${inputName}-file#${index + 1}`;
      if (!document.getElementById(fileInputName)) {
        // If the file metadata has been modified, reflect this change.
        const modifiedFile = new File([file.data], file.meta.name, { type: file.type });
        // Using a DataTransfer object is the only existing way (since 2017) to assign File objects to an <input type="file">.
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(modifiedFile);
        const fileInputEl = createUploadInputElement(fileInputName, 'file', dataTransfer.files);
        form.appendChild(fileInputEl);
      }

      createTypeAndDescriptionInputs(form, file, inputName, index);
    });
  });
}
